import { useEffect, useState } from "react";
import { ParsersPanel, NodeOverviewRow } from "../../../api/ParsersPanel";
import { useUserState } from "../../../store/user/hooks";

interface State {
  rows: NodeOverviewRow[];
  loading: boolean;
  error: string | null;
}

export function useParsersOverview(node?: string, days = 7): State {
  const { token } = useUserState();
  const [state, setState] = useState<State>({
    rows: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    if (!token) return;
    setState((s) => ({ ...s, loading: true, error: null }));

    ParsersPanel.getOverview(token, node, days)
      .then((rows) => setState({ rows, loading: false, error: null }))
      .catch((err) => {
        const msg =
          err?.response?.data?.error || err?.message || "Failed to load overview";
        setState({ rows: [], loading: false, error: msg });
      });
  }, [token, node, days]);

  return state;
}
